import Loader from "../../loader/Loader";
import {Button} from "antd";
import {SendOutlined} from "@ant-design/icons";

interface MembersLabelProps {
    isLoading: boolean;
    totalSegments: number;
    totalMembers: number;
    isEditingMode: boolean;
    totalMembersSentTo?: number;
    onResendClick: (event: any) => void;
    isResending: boolean;
}

const MembersLabel = ({ isLoading, totalMembers, totalSegments, isEditingMode, totalMembersSentTo = 0, onResendClick, isResending }: MembersLabelProps) => {
    const hasMembers = !!totalSegments && !!totalMembers;

    if(isLoading) {
        return <div><Loader size={24} /></div>;
    }

    if(!hasMembers && !isEditingMode) {
        return <div>No customers targeted.</div>;
    }

    if(hasMembers) {
        if(isEditingMode) {
            return <div><span>{totalSegments} segments</span> ({totalMembers} customers)</div>;
        } else {
            if(totalMembersSentTo < totalMembers) {
                return <div>
                    <div>Sent to {totalMembersSentTo} out of {totalMembers} customers.</div>
                </div>;
            } else {
                return <div>Sent to {totalMembersSentTo} customers.</div>;
            }
        }
    }

    return null;
}

export default MembersLabel;